import ProgressiveImageLoading, {
  Wrapper as ProgressiveImageWrapper
} from '@anm/components/image/ProgressiveImageLoading';
import styled from 'styled-components';

export const ProgressiveImageLoadingWrapper = styled(ProgressiveImageLoading)`
  object-fit: contain;
`;

export const VideoWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  ${ProgressiveImageWrapper} {
    position: static;
  }
`;

export const ImageWrapper = styled.div`
  ${ProgressiveImageWrapper} {
    position: static;
  }
`;
